/******************
	* This is a basic helper method that returns the number of visible pixels an element has in the viewport
	* Usage Example:
		var visHeight = blue.util.inViewport(element)
		//visHeight -> 32px
******************/
import { util } from '~/core';
export default function inViewport(el) {
	let elH = el.offsetHeight
	let H = window.innerHeight
	let r = el.getBoundingClientRect()
	let t = r.top
	let b = r.bottom
	return Math.max(0, t > 0 ? Math.min(elH, H - t) : Math.min(b, H))
}

util.inViewport = inViewport